var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("breadcrumb", {
          attrs: { page: _vm.page },
          on: {
            "page-change": function($event) {
              _vm.page = $event
            }
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12 flip-cards-container" },
      _vm._l(_vm.optionList, function(option, index) {
        return _c("squareOption", { key: index, attrs: { option: option } })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }